module.exports = __webpack_public_path__ + "static/head-bg_bak.9cba2ce7.png";